var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.25C15.4774 25.25 16.9403 24.959 18.3052 24.3936C19.6701 23.8283 20.9103 22.9996 21.955 21.955C22.9996 20.9103 23.8283 19.6701 24.3936 18.3052C24.959 16.9403 25.25 15.4774 25.25 14C25.25 12.5226 24.959 11.0597 24.3936 9.69481C23.8283 8.3299 22.9996 7.08971 21.955 6.04505C20.9103 5.00039 19.6701 4.17172 18.3052 3.60636C16.9403 3.04099 15.4774 2.75 14 2.75C11.0163 2.75 8.15483 3.93526 6.04505 6.04505C3.93526 8.15483 2.75 11.0163 2.75 14C2.75 16.9837 3.93526 19.8452 6.04505 21.955C8.15483 24.0647 11.0163 25.25 14 25.25ZM14 27.125C10.519 27.125 7.18064 25.7422 4.71922 23.2808C2.25781 20.8194 0.875 17.481 0.875 14C0.875 10.519 2.25781 7.18064 4.71922 4.71922C7.18064 2.25781 10.519 0.875 14 0.875C17.481 0.875 20.8194 2.25781 23.2808 4.71922C25.7422 7.18064 27.125 10.519 27.125 14C27.125 17.481 25.7422 20.8194 23.2808 23.2808C20.8194 25.7422 17.481 27.125 14 27.125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 6.5C13.3111 6.5 13.5496 6.59877 13.7254 6.77459C13.9012 6.9504 14 7.18886 14 7.4375V14.9375C14 15.1861 13.9012 15.4246 13.7254 15.6004C13.5496 15.7762 13.3111 15.875 13.0625 15.875C12.8139 15.875 12.5754 15.7762 12.3996 15.6004C12.2238 15.4246 12.125 15.1861 12.125 14.9375V7.4375C12.125 7.18886 12.2238 6.9504 12.3996 6.77459C12.5754 6.59877 12.8139 6.5 13.0625 6.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 14H20.5625C21.1875 14 21.5 14.3125 21.5 14.9375C21.5 15.5625 21.1875 15.875 20.5625 15.875H13.0625C12.4375 15.875 12.125 15.5625 12.125 14.9375C12.125 14.3125 12.4375 14 13.0625 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2440d89f6764cc1df0df333e4b45e2ff.svg";
export { ForwardRef as ReactComponent };